const moduleName = 'INSPECTION_DETAIL_ACTIONS';

const INSPECTION_DETAIL_ACTIONS = {
    LOAD_DETAIL_INSPECTION_OK: `${moduleName}_LOAD_DETAIL_INSPECTION_OK`,
    LOAD_DETAIL_INSPECTION_ERROR: `${moduleName}_LOAD_DETAIL_INSPECTION_ERROR`,
    LOAD_DETAIL: `${moduleName}_LOAD_DETAIL`,
    LOAD_DETAIL_OK: `${moduleName}_LOAD_DETAIL_OK`,
    LOAD_DETAIL_ERROR: `${moduleName}_LOAD_DETAIL_ERROR`,
    LOAD_CUSTOMER_OK: `${moduleName}_LOAD_CUSTOMER_OK`,
    LOAD_CUSTOMER_ERROR: `${moduleName}_LOAD_CUSTOMER_ERROR`,
    LOAD_STATE: `${moduleName}_LOAD_STATE`,
    LOAD_STATE_OK: `${moduleName}_LOAD_STATE_OK`,
    LOAD_STATE_ERROR: `${moduleName}_LOAD_STATE_ERROR`,
    LOAD_REGISTER_PICTURE_OBSERVED: `${moduleName}_LOAD_REGISTER_PICTURE_OBSERVED`,
    LOAD_REGISTER_PICTURE_OBSERVED_OK: `${moduleName}_LOAD_REGISTER_PICTURE_OBSERVED_OK`,
    LOAD_REGISTER_PICTURE_OBSERVED_ERROR: `${moduleName}_LOAD_REGISTER_PICTURE_OBSERVED_ERROR`,
    LOAD_DETAIL_INSPECTION_PICTURES: `${moduleName}_LOAD_DETAIL_INSPECTION_PICTURES`,
    LOAD_DETAIL_INSPECTION_PICTURES_OK: `${moduleName}_LOAD_DETAIL_INSPECTION_PICTURES_OK`,
    LOAD_DETAIL_INSPECTION_PICTURES_ERROR: `${moduleName}_LOAD_DETAIL_INSPECTION_PICTURES_ERROR`,
    LOAD_DETAIL_INSPECTION_DAMAGES: `${moduleName}_LOAD_DETAIL_INSPECTION_DAMAGES`,
    LOAD_DETAIL_INSPECTION_DAMAGES_OK: `${moduleName}_LOAD_DETAIL_INSPECTION_DAMAGES_OK`,
    LOAD_DETAIL_INSPECTION_DAMAGES_ERROR: `${moduleName}_LOAD_DETAIL_INSPECTION_DAMAGES_ERROR`,
    LOAD_INSPECTION_POLICY: `${moduleName}_LOAD_INSPECTION_POLICY`,
    LOAD_INSPECTION_POLICY_OK: `${moduleName}_LOAD_INSPECTION_POLICY_OK`,
    LOAD_INSPECTION_POLICY_ERROR: `${moduleName}_LOAD_INSPECTION_POLICY_ERROR`,
    LOAD_INSPECTION_ACCESORIES: `${moduleName}_LOAD_INSPECTION_ACCESORIES`,
    LOAD_INSPECTION_ACCESORIES_OK: `${moduleName}_LOAD_INSPECTION_ACCESORIES_OK`,
    LOAD_INSPECTION_ACCESORIES_ERROR: `${moduleName}_LOAD_INSPECTION_ACCESORIES_ERROR`,
    LOAD_INSPECTION_RESET_VALUES: `${moduleName}_LOAD_INSPECTION_RESET_VALUES`,
    LOAD_INSPECTION_APPROVED: `${moduleName}_LOAD_INSPECTION_APPROVED`,
    LOAD_INSPECTION_APPROVED_OK: `${moduleName}_LOAD_INSPECTION_APPROVED_OK`,
    LOAD_INSPECTION_APPROVED_ERROR: `${moduleName}_LOAD_INSPECTION_APPROVED_ERROR`,
    LOAD_INSPECTION_RETURN_TO_APPROVED: `${moduleName}_LOAD_INSPECTIO_RETURN_TO_APPROVED`,
    LOAD_INSPECTION_RETURN_TO_APPROVED_OK: `${moduleName}_LOAD_INSPECTION_RETURN_TO_APPROVED_OK`,
    LOAD_INSPECTION_RETURN_TO_APPROVED_ERROR: `${moduleName}_LOAD_INSPECTION_RETURN_TO_APPROVED_ERROR`,

    LOAD_INSPECTION_RETURN_TO_IN_PERSON: `${moduleName}_LOAD_INSPECTION_RETURN_TO_IN_PERSON`,
    LOAD_INSPECTION_RETURN_TO_IN_PERSON_OK: `${moduleName}_LOAD_INSPECTION_RETURN_TO_IN_PERSON_OK`,
    LOAD_INSPECTION_RETURN_TO_IN_PERSON_ERROR: `${moduleName}_LOAD_INSPECTION_RETURN_TO_IN_PERSON_ERROR`,

    LOAD_INSPECTION_IN_PERSON_TO_CREATE: `${moduleName}_LOAD_INSPECTION_IN_PERSON_TO_CREATE`,
    LOAD_INSPECTION_IN_PERSON_TO_CREATE_OK: `${moduleName}_LOAD_INSPECTION_IN_PERSON_TO_CREATE_OK`,
    LOAD_INSPECTION_IN_PERSON_TO_CREATE_ERROR: `${moduleName}_LOAD_INSPECTION_IN_PERSON_TO_CREATE_ERROR`,

    //LOADS PARA ACTION changeInpersonToReturn

    LOAD_INSPECTION_IN_PERSON_TO_RETURN: `${moduleName}_LOAD_INSPECTION_IN_PERSON_TO_RETURN`,
    LOAD_INSPECTION_IN_PERSON_TO_RETURN_OK: `${moduleName}_LOAD_INSPECTION_IN_PERSON_TO_RETURN_OK`,
    LOAD_INSPECTION_IN_PERSON_TO_RETURN_ERROR: `${moduleName}_LOAD_INSPECTION_IN_PERSON_TO_RETURN_ERROR`,

    LOAD_INSPECTION_UPDATE_VEHICLE_PLATE: `${moduleName}_LOAD_INSPECTION_UPDATE_VEHICLE_PLATE`,
    LOAD_INSPECTION_UPDATE_VEHICLE_PLATE_OK: `${moduleName}_LOAD_INSPECTION_UPDATE_VEHICLE_PLATE_OK`,
    LOAD_INSPECTION_UPDATE_VEHICLE_PLATE_ERROR: `${moduleName}_LOAD_INSPECTION_UPDATE_VEHICLE_PLATE_ERROR`,

    LOAD_INSPECTION_REMOVE_INSPECTIONS: `${moduleName}_LOAD_INSPECTION_REMOVE_INSPECTIONS`,
    LOAD_INSPECTION_REMOVE_INSPECTIONS_OK: `${moduleName}_LOAD_INSPECTION_REMOVE_INSPECTIONS_OK`,
    LOAD_INSPECTION_REMOVE_INSPECTIONS_ERROR: `${moduleName}_LOAD_INSPECTION_REMOVE_INSPECTIONS_ERROR`,

    LOAD_INSPECTION_PRESENCIAL: `${moduleName}_LOAD_INSPECTION_PRESENCIAL`,
    LOAD_INSPECTION_PRESENCIAL_OK: `${moduleName}_LOAD_INSPECTION_PRESENCIAL_OK`,
    LOAD_INSPECTION_PRESENCIAL_ERROR: `${moduleName}_LOAD_INSPECTION_PRESENCIAL_ERROR`,
    LOAD_INSPECTION_PRESENCIAL_RESET: `${moduleName}_LOAD_INSPECTION_PRESENCIAL_RESET`,
    LOAD_INSPECTION_REJECTED: `${moduleName}_LOAD_INSPECTION_REJECTED`,
    LOAD_INSPECTION_REJECTED_OK: `${moduleName}_LOAD_INSPECTION_REJECTED_OK`,
    LOAD_INSPECTION_REJECTED_ERROR: `${moduleName}_LOAD_INSPECTION_REJECTED_ERROR`,
    LOAD_INSPECTION_REJECTED_RESET: `${moduleName}_LOAD_INSPECTION_REJECTED_RESET`,
    LOAD_INSPECTION_DERIVE: `${moduleName}_LOAD_INSPECTION_DERIVE`,
    LOAD_INSPECTION_DERIVE_OK: `${moduleName}_LOAD_INSPECTION_DERIVE_OK`,
    LOAD_INSPECTION_DERIVE_ERROR: `${moduleName}_LOAD_INSPECTION_DERIVE_ERROR`,
    LOAD_INSPECTION_DERIVE_RESET: `${moduleName}_LOAD_INSPECTION_DERIVE_RESET`,
    // LOAD_INSPECTION_REPORT: `${moduleName}_LOAD_INSPECTION_REPORT`,
    // LOAD_INSPECTION_REPORT_OK: `${moduleName}_LOAD_INSPECTION_REPORT_OK`,
    // LOAD_INSPECTION_REPORT_ERROR: `${moduleName}_LOAD_INSPECTION_REPORT_ERROR`,
    // LOAD_INSPECTION_REPORT_RESET: `${moduleName}_LOAD_INSPECTION_REPORT_RESET`,
    LOAD_INSPECTION_APPROVED_RESET: `${moduleName}_LOAD_INSPECTION_APPROVED_RESET`,
    LOAD_INSPECTION_RETURN: `${moduleName}_LOAD_INSPECTION_RETURN`,
    LOAD_INSPECTION_RETURN_OK: `${moduleName}_LOAD_INSPECTION_RETURN_OK`,
    LOAD_INSPECTION_RETURN_ERROR: `${moduleName}_LOAD_INSPECTION_RETURN_ERROR`,
    LOAD_INSPECTION_RETURN_RESET: `${moduleName}_LOAD_INSPECTION_RETURN_RESET`,
    CHANGE_COMMENT_DAMAGES: `${moduleName}_CHANGE_COMMENT_DAMAGES`,
    CHANGE_COMMENT_PICTURES: `${moduleName}_CHANGE_COMMENT_PICTURES`,
    SAVE_COMMENTS_DAMAGES:  `${moduleName}_SAVE_COMMENTS_DAMAGES`,
    SAVE_COMMENTS_DAMAGES_OK:  `${moduleName}_SAVE_COMMENTS_DAMAGES_OK`,
    SAVE_COMMENTS_DAMAGES_ERROR:  `${moduleName}_SAVE_COMMENTS_DAMAGES_ERROR`,
    SAVE_COMMENTS_PICTURES:  `${moduleName}_SAVE_COMMENTS_PICTURES`,
    SAVE_COMMENTS_PICTURES_OK:  `${moduleName}_SAVE_COMMENTS_PICTURES_OK`,
    SAVE_COMMENTS_PICTURES_ERROR:  `${moduleName}_SAVE_COMMENTS_PICTURES_ERROR`,
    VALIDATE_BUTTON_OBSERVATION:  `${moduleName}_VALIDATE_BUTTON_OBSERVATION`,
    VALIDATE_BUTTON_OBSERVATION_OK:  `${moduleName}_VALIDATE_BUTTON_OBSERVATION_OK`,
    ADD_PICTURE_OBSERVATION:  `${moduleName}_ADD_PICTURE_OBSERVATION`,
    REMOVE_PICTURE_OBSERVATION:  `${moduleName}_REMOVE_PICTURE_OBSERVATION`,
    ADD_ACCESSORY_OBSERVATION:  `${moduleName}_ADD_ACCESSORY_OBSERVATION`,
    ADD_DAMAGE_OBSERVATION:  `${moduleName}_ADD_DAMAGE_OBSERVATION`,
    REMOVE_ACCESSORY_OBSERVATION:  `${moduleName}_REMOVE_ACCESSORY_OBSERVATION`,
    LOAD_PICTURES_OBSERVEDS_ERROR: `${moduleName}_LOAD_PICTURES_OBSERVEDS_ERROR`,
    REMOVE_DAMAGE_OBSERVATION:  `${moduleName}_REMOVE_DAMAGE_OBSERVATION`,
    LOAD_PICTURES_OBSERVEDS: `${moduleName}_LOAD_PICTURES_OBSERVEDS`,
    LOAD_PICTURES_OBSERVEDS_OK: `${moduleName}_LOAD_PICTURES_OBSERVEDS_OK`,
    RESET_VALUE: `${moduleName}_RESET_VALUE`,
};

export default INSPECTION_DETAIL_ACTIONS;



// WEBPACK FOOTER //
// ./src/constants/actions/inspection.js